/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { UserStatus } from '../entities/UserStatus'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { z } from 'zod'

export const userStatusSchema = z.enum(['active', 'inactive', 'pending']) as unknown as ToZod<UserStatus>